import axios, { CancelToken } from 'axios';
import { CANCEL } from 'redux-saga';
import { assocPath } from 'ramda';

const addRequestCancel = (apiMethod, paramPath) => (...args) => {
    const source = CancelToken.source();
    const argsWithCancel = assocPath([paramPath, 'cancelToken'], source.token, args);

    const request = apiMethod(...argsWithCancel);
    request[CANCEL] = () => {
        source.cancel();
    };

    return request;
};

const sourceGet = axios.get;
axios.get = addRequestCancel(sourceGet, 1);

const sourcePost = axios.post;
axios.post = addRequestCancel(sourcePost, 2);

const sourcePut = axios.put;
axios.put = addRequestCancel(sourcePut, 2);



// WEBPACK FOOTER //
// ./src/utils/httpCancelPromise.js